// extracted by css-extract-rspack-plugin
export default {"formBody":"R9Report__formBody--_vcwk","field":"R9Report__field--qkYE2","indent":"R9Report__indent--jXNQc"};